import { Plus } from "lucide-react";

interface AddCategoryTileProps {
  isHe: boolean;
  onClick: () => void;
}

export function AddCategoryTile({ isHe, onClick }: AddCategoryTileProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex min-h-[200px] cursor-pointer flex-col items-center justify-center gap-2 rounded-[14px] border-[1.5px] border-dashed border-[var(--border-color)] bg-transparent p-8 text-[13px] text-[var(--text-muted)] transition-all duration-150 [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] hover:border-[var(--fg-accent)] hover:text-[var(--fg-accent)]"
      aria-label={isHe ? "הוסף קטגוריה" : "Add category"}
    >
      <Plus className="h-5 w-5" />
      <span>{isHe ? "הוסף קטגוריה" : "Add category"}</span>
    </button>
  );
}

